import { stripInline } from "@/lib/article-blocks";
import { firstSentence } from "@/lib/blog-text";

/**
 * Key takeaways for an article: the hand-curated list when present, otherwise
 * three snippets derived from quick-answer blocks and then the first body
 * paragraphs (first sentence of each, Markdown stripped).
 */
export function articleTakeaways(post: {
  takeaways?: string[];
  body: { a?: string; p?: string }[];
}): string[] {
  if (post.takeaways && post.takeaways.length > 0) return post.takeaways;
  const answers = post.body.filter((b) => b.a).map((b) => b.a as string);
  if (answers.length >= 3)
    return answers.slice(0, 3).map((s) => firstSentence(stripInline(s), 220));
  const paras = post.body
    .filter((b) => b.p)
    .map((b) => b.p as string)
    .slice(0, 4);
  return [...answers, ...paras].slice(0, 3).map((s) => firstSentence(stripInline(s), 220));
}
